import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  const currentYear: number = new Date().getFullYear();
  return (
    <Box p={2} component={'footer'} bgcolor={'primary.main'} >
      <Typography color='common.white' fontWeight={500} textAlign={'center'}>{currentYear} &copy; All rights reserved by Storage360, LP</Typography>
    </Box>
  )
}

export default Footer